/* ==========================================================================
 * Berry Maroquinerie — Wishlist « Coup de cœur » + Comparateur global
 * - Sans connexion, persistance localStorage (pas de cookies)
 * - Cœur wishlist : cartes + fiche produit (photo) + compteur header + page.
 * - Comparateur : case « Comparer » en bas-gauche de TOUTES les vignettes
 *   (collections, marques, recherche, home, wishlist). Sélection persistée
 *   (localStorage berry_compare_v1), barre flottante discrète en bas, modale
 *   tableau. Specs parsées côté client depuis /products/{h}.js (tags +
 *   description : dimensions / capacité / poids / matière / couleur).
 * Aucune dépendance. Compatible navigation Horizon.
 * ========================================================================== */
(function () {
  'use strict';

  var STORE_KEY = 'berry_wishlist_v1';
  var CMP_KEY = 'berry_compare_v1';
  var COMPARE_MAX = 4;
  var HEART_SVG =
    '<svg viewBox="0 0 24 24" aria-hidden="true">' +
    '<path class="berry-wl-heart__fill" d="M12 21s-7.5-4.7-10-9.3C.4 8.4 2 4.9 5.3 4.9c2 0 3.4 1.2 4.7 2.9 1.3-1.7 2.7-2.9 4.7-2.9 3.3 0 4.9 3.5 3.3 6.8C19.5 16.3 12 21 12 21z"/>' +
    '<path class="berry-wl-heart__stroke" d="M12 21s-7.5-4.7-10-9.3C.4 8.4 2 4.9 5.3 4.9c2 0 3.4 1.2 4.7 2.9 1.3-1.7 2.7-2.9 4.7-2.9 3.3 0 4.9 3.5 3.3 6.8C19.5 16.3 12 21 12 21z"/>' +
    '</svg>';

  var WISHLIST_PATH = '/pages/coup-de-coeur';

  /* ---- Clé unique (variant si présent, sinon produit) ------------------- */
  function keyOf(handle, variantId) { return variantId ? ('v:' + variantId) : ('h:' + handle); }

  /* ---- Store wishlist (localStorage) ------------------------------------ */
  var Store = {
    read: function () {
      try {
        var raw = window.localStorage.getItem(STORE_KEY);
        var arr = raw ? JSON.parse(raw) : [];
        return Array.isArray(arr) ? arr : [];
      } catch (e) { return []; }
    },
    write: function (arr) {
      try { window.localStorage.setItem(STORE_KEY, JSON.stringify(arr)); } catch (e) {}
      emitChange();
    },
    has: function (handle, variantId) {
      var k = keyOf(handle, variantId);
      return this.read().some(function (i) { return keyOf(i.handle, i.variantId) === k; });
    },
    add: function (handle, variantId) {
      if (!handle || this.has(handle, variantId)) return;
      var arr = this.read();
      arr.push({ handle: handle, variantId: variantId || null, addedAt: Date.now() });
      this.write(arr);
    },
    remove: function (handle, variantId) {
      var k = keyOf(handle, variantId);
      this.write(this.read().filter(function (i) { return keyOf(i.handle, i.variantId) !== k; }));
    },
    toggle: function (handle, variantId) {
      if (this.has(handle, variantId)) { this.remove(handle, variantId); return false; }
      this.add(handle, variantId); return true;
    },
    count: function () { return this.read().length; }
  };
  function emitChange() {
    document.dispatchEvent(new CustomEvent('berry:wishlist:change', { detail: { count: Store.count() } }));
  }

  /* ---- Store comparateur (localStorage) --------------------------------- */
  var Compare = {
    read: function () {
      try {
        var raw = window.localStorage.getItem(CMP_KEY);
        var arr = raw ? JSON.parse(raw) : [];
        return Array.isArray(arr) ? arr : [];
      } catch (e) { return []; }
    },
    write: function (arr) {
      try { window.localStorage.setItem(CMP_KEY, JSON.stringify(arr)); } catch (e) {}
      document.dispatchEvent(new CustomEvent('berry:compare:change'));
    },
    has: function (handle, variantId) {
      var k = keyOf(handle, variantId);
      return this.read().some(function (i) { return keyOf(i.handle, i.variantId) === k; });
    },
    add: function (handle, variantId) {
      if (!handle || this.has(handle, variantId)) return true;
      var arr = this.read();
      if (arr.length >= COMPARE_MAX) return 'full';
      arr.push({ handle: handle, variantId: variantId || null });
      this.write(arr);
      return true;
    },
    remove: function (handle, variantId) {
      var k = keyOf(handle, variantId);
      this.write(this.read().filter(function (i) { return keyOf(i.handle, i.variantId) !== k; }));
    },
    toggle: function (handle, variantId) {
      if (this.has(handle, variantId)) { this.remove(handle, variantId); return false; }
      return this.add(handle, variantId); // true | 'full'
    },
    clear: function () { this.write([]); },
    count: function () { return this.read().length; }
  };

  /* ---- Helpers ---------------------------------------------------------- */
  function handleFromUrl(url) {
    if (!url) return null;
    var m = String(url).match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }
  function variantFromUrl(url) {
    if (!url) return null;
    var m = String(url).match(/[?&]variant=(\d+)/);
    return m ? m[1] : null;
  }
  function currentProductHandle() {
    if (!/\/products\//.test(window.location.pathname)) return null;
    return handleFromUrl(window.location.pathname);
  }
  function formatMoney(cents) {
    try {
      return (cents / 100).toLocaleString('fr-FR', {
        style: 'currency', currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR'
      });
    } catch (e) { return (cents / 100).toFixed(2) + ' €'; }
  }
  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ---- Résolution du variant selon le contexte -------------------------- */
  function pdpVariantId() {
    var main = document.querySelector('main[data-template^="product"]') || document;
    var handle = currentProductHandle();
    var idInput = main.querySelector('[name="id"]');
    var vid = idInput && idInput.value ? String(idInput.value) : variantFromUrl(window.location.search);
    var set = {};
    main.querySelectorAll('a[href*="variant="]').forEach(function (a) {
      var href = a.getAttribute('href') || '';
      if (handleFromUrl(href) === handle) { var v = variantFromUrl(href); if (v) set[v] = 1; }
    });
    var sel = main.querySelector('select[name="id"]');
    var multi = Object.keys(set).length > 1 ||
      !!main.querySelector('variant-selects') ||
      (sel && sel.options && sel.options.length > 1) ||
      main.querySelectorAll('.product-form fieldset input[type="radio"], variant-selects input[type="radio"]').length > 1;
    return multi ? vid : null;
  }
  function cardVariantId(card, handle) {
    var a = card.querySelector('.berry-card-variants__item.is-active');
    var href = a && a.getAttribute('href');
    if (!href) return null;
    if (handleFromUrl(href) === handle) return variantFromUrl(href);
    return null; // coloris = produit séparé -> niveau handle
  }

  /* ---- Bouton cœur ------------------------------------------------------ */
  function makeHeart(handle, variantFn, isPdp) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'berry-wl-heart' + (isPdp ? ' berry-wl-heart--pdp' : '');
    btn.setAttribute('aria-label', 'Ajouter aux coups de cœur');
    btn.dataset.berryWlHandle = handle;
    btn.__berryVariant = variantFn || function () { return null; };
    btn.setAttribute('aria-pressed', Store.has(handle, btn.__berryVariant()) ? 'true' : 'false');
    btn.innerHTML = HEART_SVG;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var vid = btn.__berryVariant();
      var active = Store.toggle(handle, vid);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.classList.remove('is-animating');
      void btn.offsetWidth;
      btn.classList.add('is-animating');
    });
    return btn;
  }

  /* ---- Case comparateur (vignette) -------------------------------------- */
  function makeCompareCheck(handle, variantFn) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'berry-cmp-check';
    btn.dataset.berryCmpHandle = handle;
    btn.__cmpVariant = variantFn || function () { return null; };
    btn.setAttribute('aria-label', 'Comparer ce produit');
    btn.setAttribute('aria-pressed', Compare.has(handle, btn.__cmpVariant()) ? 'true' : 'false');
    btn.innerHTML =
      '<span class="berry-cmp-check__box" aria-hidden="true"></span>' +
      '<span class="berry-cmp-check__label">Comparer</span>';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var vid = btn.__cmpVariant();
      var res = Compare.toggle(handle, vid);
      if (res === 'full') { flashCompareBar(); return; }
      btn.setAttribute('aria-pressed', res ? 'true' : 'false');
    });
    return btn;
  }

  function cardMedia(card) {
    // Cadre STABLE : sur les cartes natives, le diaporama fait défiler les slides
    // au survol ; on vise slideshow-component (fixe) et non .product-media (un slide).
    return card.querySelector('slideshow-component') ||
      card.querySelector('.bp-media, .berry-wl-item__media, .card__media') ||
      card.querySelector('.product-media') ||
      (card.querySelector('img') && card.querySelector('img').parentElement) || card;
  }

  /* ---- Injection : cœur sur cartes (natives + .bp-card home) ------------ */
  function injectCardHearts(root) {
    (root || document).querySelectorAll('product-card:not([data-berry-wl]), .bp-card:not([data-berry-wl])').forEach(function (card) {
      card.setAttribute('data-berry-wl', '');
      var link = card.querySelector('.product-card__link, a[href*="/products/"]') || card;
      var handle = handleFromUrl(link && link.getAttribute('href'));
      if (!handle) return;
      if (getComputedStyle(card).position === 'static') card.style.position = 'relative';
      card.appendChild(makeHeart(handle, function () { return cardVariantId(card, handle); }, false));
    });
  }

  /* ---- Injection : case comparateur sur TOUTES les vignettes ------------ */
  function injectCardCompare(root) {
    (root || document)
      .querySelectorAll('product-card:not([data-berry-cmp]), .bp-card:not([data-berry-cmp]), .berry-wl-item:not([data-berry-cmp])')
      .forEach(function (card) {
        card.setAttribute('data-berry-cmp', '');
        var handle, variantFn;
        if (card.classList.contains('berry-wl-item')) {
          handle = card.dataset.handle;
          var vid = card.dataset.variantId || null;
          variantFn = function () { return vid; };
        } else {
          var link = card.querySelector('.product-card__link, .bp-card__link, a[href*="/products/"]') || card;
          handle = handleFromUrl(link && link.getAttribute('href'));
          variantFn = function () { return cardVariantId(card, handle); };
        }
        if (!handle) return;
        var media = cardMedia(card);
        if (getComputedStyle(media).position === 'static') media.style.position = 'relative';
        media.appendChild(makeCompareCheck(handle, variantFn));
      });
  }

  /* ---- Injection : fiche produit (un seul cœur, sur la photo) ----------- */
  function injectPdpHeart() {
    var handle = currentProductHandle();
    if (!handle) return;
    var main = document.querySelector('main[data-template^="product"]') || document;
    if (main.querySelector('.berry-wl-heart--pdp-media')) return;
    var media = main.querySelector('slideshow-component, .product-media-container, .product-media, media-gallery');
    if (!media) return;
    if (getComputedStyle(media).position === 'static') media.style.position = 'relative';
    var mh = makeHeart(handle, pdpVariantId, false);
    mh.classList.add('berry-wl-heart--pdp-media');
    media.appendChild(mh);
  }

  /* ---- Compteur header (auto-injecté à côté du panier) ------------------ */
  function ensureHeaderLink() {
    document.querySelectorAll('header-actions').forEach(function (ha) {
      if (ha.querySelector('.berry-wl-headlink')) return;
      var a = document.createElement('a');
      a.href = WISHLIST_PATH;
      a.className = 'header-actions__action berry-wl-headlink';
      a.setAttribute('aria-label', 'Coups de cœur');
      a.innerHTML =
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path class="berry-wl-heart__stroke" d="M12 21s-7.5-4.7-10-9.3C.4 8.4 2 4.9 5.3 4.9c2 0 3.4 1.2 4.7 2.9 1.3-1.7 2.7-2.9 4.7-2.9 3.3 0 4.9 3.5 3.3 6.8C19.5 16.3 12 21 12 21z"/></svg>' +
        '<span class="berry-wl-count" data-berry-wl-count hidden>0</span>';
      ha.insertBefore(a, ha.firstChild);
    });
    var n = Store.count();
    document.querySelectorAll('[data-berry-wl-count]').forEach(function (c) {
      c.textContent = n;
      if (n > 0) c.removeAttribute('hidden'); else c.setAttribute('hidden', '');
    });
  }

  /* ---- Synchronisation des états ---------------------------------------- */
  function syncHearts() {
    document.querySelectorAll('.berry-wl-heart[data-berry-wl-handle]').forEach(function (btn) {
      var vid = btn.__berryVariant ? btn.__berryVariant() : null;
      btn.setAttribute('aria-pressed', Store.has(btn.dataset.berryWlHandle, vid) ? 'true' : 'false');
    });
  }
  function syncCompareChecks() {
    var atMax = Compare.count() >= COMPARE_MAX;
    document.querySelectorAll('.berry-cmp-check[data-berry-cmp-handle]').forEach(function (btn) {
      var vid = btn.__cmpVariant ? btn.__cmpVariant() : null;
      var on = Compare.has(btn.dataset.berryCmpHandle, vid);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.classList.toggle('is-disabled', !on && atMax);
    });
  }

  /* ---- Barre flottante du comparateur (site-wide) ----------------------- */
  function ensureCompareBar() {
    var bar = document.querySelector('.berry-cmp-bar');
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'berry-cmp-bar';
      bar.setAttribute('role', 'region');
      bar.setAttribute('aria-label', 'Comparateur');
      bar.innerHTML =
        '<span class="berry-cmp-bar__count"></span>' +
        '<button type="button" class="berry-cmp-bar__go">Comparer</button>' +
        '<button type="button" class="berry-cmp-bar__clear" aria-label="Vider la sélection">&times;</button>';
      document.body.appendChild(bar);
      bar.querySelector('.berry-cmp-bar__go').addEventListener('click', function () {
        var list = Compare.read().map(function (i) { return { handle: i.handle, variantId: i.variantId }; });
        if (list.length >= 2) openCompareModal(list);
      });
      bar.querySelector('.berry-cmp-bar__clear').addEventListener('click', function () { Compare.clear(); });
    }
    updateCompareBar();
  }
  function updateCompareBar() {
    var bar = document.querySelector('.berry-cmp-bar');
    if (!bar) return;
    var n = Compare.count();
    var countEl = bar.querySelector('.berry-cmp-bar__count');
    var go = bar.querySelector('.berry-cmp-bar__go');
    countEl.textContent = n < 2
      ? (n + ' produit' + (n > 1 ? 's' : '') + ' · min 2 pour comparer')
      : (n + ' produits sélectionnés');
    go.disabled = n < 2;
    go.textContent = n >= 2 ? 'Comparer (' + n + ')' : 'Comparer';
    if (n >= 1) bar.classList.add('is-visible'); else bar.classList.remove('is-visible');
  }
  function flashCompareBar() {
    var bar = document.querySelector('.berry-cmp-bar');
    if (!bar) return;
    var c = bar.querySelector('.berry-cmp-bar__count');
    c.textContent = 'Maximum ' + COMPARE_MAX + ' produits';
    bar.classList.add('is-visible', 'is-flash');
    setTimeout(function () { bar.classList.remove('is-flash'); updateCompareBar(); }, 1500);
  }

  /* ---- Cache produit + fetch -------------------------------------------- */
  var productCache = {};
  function fetchProduct(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { if (p) productCache[handle] = p; return p; })
      .catch(function () { return null; });
  }
  function resolveVariant(p, variantId) {
    var v = null;
    if (variantId) v = (p.variants || []).find(function (x) { return String(x.id) === String(variantId); });
    if (!v) v = (p.variants || []).find(function (x) { return x.available; }) || (p.variants || [])[0] || {};
    return v;
  }

  /* ---- Extraction des caractéristiques (specs) -------------------------- */
  function textFromHtml(html) {
    var d = document.createElement('div');
    d.innerHTML = html || '';
    return (d.textContent || '').replace(/ /g, ' ').replace(/\s+/g, ' ').trim();
  }
  function tagValue(tags, prefix) {
    var up = prefix.toUpperCase();
    var t = (tags || []).find(function (x) { return String(x).toUpperCase().indexOf(up) === 0; });
    if (!t) return '';
    return t.slice(prefix.length).replace(/^_/, '').trim();
  }
  function parseSpecs(p, v) {
    var txt = textFromHtml(p.description || p.body_html || '');
    var specs = {};

    var dim = txt.match(/dimensions?[^0-9]*?(\d+[.,]?\d*)\s*(?:x|×)\s*(?:[^0-9]{0,18}?)(\d+[.,]?\d*)\s*(?:x|×)\s*(?:[^0-9]{0,18}?)(\d+[.,]?\d*)/i);
    if (dim) specs.dimensions = [dim[1], dim[2], dim[3]].map(function (n) { return n.replace(',', '.'); }).join(' × ') + ' cm';

    var cap = txt.match(/capacit[ée][^0-9]*?(\d+[.,]?\d*)\s*L\b/i) || txt.match(/(\d+[.,]?\d*)\s*L\b/i);
    if (cap) specs.capacite = cap[1].replace(',', '.') + ' L';

    var poids = txt.match(/poids[^0-9]*?(\d+[.,]?\d*)\s*(kg|g)\b/i);
    if (poids) specs.poids = poids[1].replace(',', '.') + ' ' + poids[2].toLowerCase();

    var mat = tagValue(p.tags, 'MATIERE');
    if (!mat) {
      var mm = txt.match(/\[\s*mati[èe]re\s*\][\s:]*([^\[\n.]{2,40})/i) ||
               txt.match(/(?:^|[\s>·-])mati[èe]re\s*:\s*([^\[\n.]{2,40})/i);
      if (mm) mat = mm[1].trim().split(/\s+(?=[A-ZÀ-Þ])/)[0];
    }
    if (mat) specs.matiere = mat.trim().replace(/^[\s:.\-–—•·]+|[\s:.\-–—•·]+$/g, '').replace(/\s+/g, ' ');

    var coul = tagValue(p.tags, 'COULEUR');
    if (!coul && v && v.title && v.title !== 'Default Title') coul = v.title;
    if (coul) specs.couleur = coul.trim();

    specs.categorie = (p.type && p.type.trim()) || tagValue(p.tags, 'CATEGORIE') || '';

    return specs;
  }

  /* ---- Page « Coup de cœur » -------------------------------------------- */
  function renderWishlistPage(rootEl) {
    var items = Store.read();

    if (!items.length) {
      rootEl.innerHTML =
        '<div class="berry-wl-empty">Vous n\'avez pas encore de coup de cœur.<br>' +
        '<a href="/collections/all">Parcourir la boutique</a></div>';
      return;
    }

    rootEl.innerHTML = '<div class="berry-wl-grid"></div>';
    var grid = rootEl.querySelector('.berry-wl-grid');

    items.forEach(function (item) {
      fetchProduct(item.handle).then(function (p) {
        if (!p) return;
        var v = resolveVariant(p, item.variantId);

        var img = (v.featured_image && v.featured_image.src) || p.featured_image || (p.images && p.images[0]) || '';
        var url = '/products/' + p.handle + (item.variantId ? ('?variant=' + item.variantId) : '');
        var priceHtml = formatMoney(v.price != null ? v.price : p.price);
        if (v.compare_at_price && v.compare_at_price > v.price) {
          priceHtml += '<del>' + formatMoney(v.compare_at_price) + '</del>';
        }
        var colorText = (item.variantId && v.title && v.title !== 'Default Title') ? v.title : '';

        var el = document.createElement('div');
        el.className = 'berry-wl-item';
        el.dataset.handle = p.handle;
        el.dataset.variantId = item.variantId || '';
        el.innerHTML =
          '<a class="berry-wl-item__media" href="' + url + '">' +
            (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
          '</a>' +
          '<button type="button" class="berry-wl-item__remove" aria-label="Retirer">&times;</button>' +
          '<div class="berry-wl-item__body">' +
            (p.vendor ? '<span class="berry-wl-item__brand">' + escapeHtml(p.vendor) + '</span>' : '') +
            '<a class="berry-wl-item__title" href="' + url + '">' + escapeHtml(p.title) + '</a>' +
            (colorText ? '<span class="berry-wl-item__variant">' + escapeHtml(colorText) + '</span>' : '') +
            '<span class="berry-wl-item__price">' + priceHtml + '</span>' +
            '<button type="button" class="berry-wl-item__add"' + (v.available ? '' : ' disabled') +
              ' data-variant-id="' + (v.id || '') + '">' +
              (v.available ? 'Ajouter au panier' : 'Indisponible') +
            '</button>' +
          '</div>';

        el.querySelector('.berry-wl-item__remove').addEventListener('click', function () {
          Store.remove(item.handle, item.variantId);
          el.remove();
          if (!Store.count()) renderWishlistPage(rootEl);
        });

        var addBtn = el.querySelector('.berry-wl-item__add');
        if (v.available && v.id) {
          addBtn.addEventListener('click', function () {
            addBtn.disabled = true;
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: v.id, quantity: 1 })
            }).then(function () {
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              addBtn.textContent = 'Ajouté ✓';
              setTimeout(function () { addBtn.textContent = 'Ajouter au panier'; addBtn.disabled = false; }, 1600);
            }).catch(function () { addBtn.disabled = false; });
          });
        }
        grid.appendChild(el);
      });
    });
  }

  /* ---- Comparateur : modale --------------------------------------------- */
  function openCompareModal(sel) {
    Promise.all(sel.map(function (s) {
      return fetchProduct(s.handle).then(function (p) { return p ? { p: p, variantId: s.variantId } : null; });
    })).then(function (list) {
      list = list.filter(Boolean);
      if (list.length < 2) return;
      var modal = buildCompareModal(list);
      document.body.appendChild(modal);
      document.body.style.overflow = 'hidden';
    });
  }

  function buildCompareModal(list) {
    var cols = list.map(function (entry) {
      var p = entry.p, v = resolveVariant(p, entry.variantId);
      var specs = parseSpecs(p, v);
      var priceHtml = formatMoney(v.price != null ? v.price : p.price);
      if (v.compare_at_price && v.compare_at_price > v.price) {
        priceHtml += ' <del>' + formatMoney(v.compare_at_price) + '</del>';
      }
      return {
        title: p.title,
        vendor: p.vendor || '',
        url: '/products/' + p.handle + (entry.variantId ? ('?variant=' + entry.variantId) : ''),
        img: (v.featured_image && v.featured_image.src) || p.featured_image || (p.images && p.images[0]) || '',
        priceHtml: priceHtml,
        specs: specs,
        vid: v.id,
        available: !!v.available
      };
    });

    var rowDefs = [
      { key: 'couleur', label: 'Coloris' },
      { key: 'matiere', label: 'Matière' },
      { key: 'dimensions', label: 'Dimensions (H×L×P)' },
      { key: 'capacite', label: 'Capacité' },
      { key: 'poids', label: 'Poids' },
      { key: 'categorie', label: 'Catégorie' }
    ].filter(function (r) {
      return cols.some(function (c) { return c.specs[r.key]; });
    });

    var thead =
      '<tr><th class="berry-wl-ctable__rowlabel"></th>' +
      cols.map(function (c) {
        return '<th>' +
          '<a class="berry-wl-ctable__pmedia" href="' + c.url + '">' +
            (c.img ? '<img class="berry-wl-ctable__img" src="' + c.img + '" alt="" loading="lazy">' : '') +
          '</a>' +
          (c.vendor ? '<span class="berry-wl-ctable__brand">' + escapeHtml(c.vendor) + '</span>' : '') +
          '<a class="berry-wl-ctable__ptitle" href="' + c.url + '">' + escapeHtml(c.title) + '</a>' +
          '<span class="berry-wl-ctable__price">' + c.priceHtml + '</span>' +
          '</th>';
      }).join('') + '</tr>';

    var tbody = rowDefs.map(function (r) {
      return '<tr><td class="berry-wl-ctable__rowlabel">' + r.label + '</td>' +
        cols.map(function (c) {
          var val = c.specs[r.key];
          return '<td>' + (val ? escapeHtml(val) : '<span class="berry-wl-ctable__na">—</span>') + '</td>';
        }).join('') + '</tr>';
    }).join('');

    var ctaRow = '<tr><td class="berry-wl-ctable__rowlabel"></td>' +
      cols.map(function (c) {
        return '<td>' +
          (c.available && c.vid
            ? '<button type="button" class="berry-wl-ctable__add" data-variant-id="' + c.vid + '">Ajouter au panier</button>'
            : '<span class="berry-wl-ctable__na">Indisponible</span>') +
          '</td>';
      }).join('') + '</tr>';

    var overlay = document.createElement('div');
    overlay.className = 'berry-wl-modal';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Comparateur de produits');
    overlay.innerHTML =
      '<div class="berry-wl-modal__backdrop"></div>' +
      '<div class="berry-wl-modal__panel">' +
        '<div class="berry-wl-modal__head">' +
          '<h2>Comparer</h2>' +
          '<button type="button" class="berry-wl-modal__close" aria-label="Fermer">&times;</button>' +
        '</div>' +
        '<div class="berry-wl-modal__scroll">' +
          '<table class="berry-wl-ctable"><thead>' + thead + '</thead>' +
          '<tbody>' + tbody + ctaRow + '</tbody></table>' +
        '</div>' +
      '</div>';

    function close() {
      overlay.remove();
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e) { if (e.key === 'Escape') close(); }

    overlay.querySelector('.berry-wl-modal__backdrop').addEventListener('click', close);
    overlay.querySelector('.berry-wl-modal__close').addEventListener('click', close);
    document.addEventListener('keydown', onKey);

    overlay.querySelectorAll('.berry-wl-ctable__add').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-variant-id');
        if (!id) return;
        btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: id, quantity: 1 })
        }).then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          btn.textContent = 'Ajouté ✓';
          setTimeout(function () { btn.textContent = 'Ajouter au panier'; btn.disabled = false; }, 1600);
        }).catch(function () { btn.disabled = false; });
      });
    });

    return overlay;
  }

  /* ---- API publique ----------------------------------------------------- */
  window.BerryWishlistCompare = { open: openCompareModal, store: Compare, cache: productCache, parseSpecs: parseSpecs };
  window.BerryWishlist = {
    store: Store,
    has: function (h, v) { return Store.has(h, v); },
    toggle: function (h, v) { return Store.toggle(h, v); },
    count: function () { return Store.count(); }
  };

  /* ---- Bootstrap -------------------------------------------------------- */
  function refreshUI(root) {
    injectCardHearts(root);
    injectCardCompare(root);
    injectPdpHeart();
    ensureHeaderLink();
    ensureCompareBar();
    syncHearts();
    syncCompareChecks();
    var page = document.getElementById('berry-wishlist-root');
    if (page && !page.dataset.rendered) { page.dataset.rendered = '1'; renderWishlistPage(page); }
  }

  document.addEventListener('berry:wishlist:change', function () { ensureHeaderLink(); syncHearts(); });
  document.addEventListener('berry:compare:change', function () { updateCompareBar(); syncCompareChecks(); });
  window.addEventListener('storage', function (e) {
    if (e.key === STORE_KEY) { ensureHeaderLink(); syncHearts(); }
    if (e.key === CMP_KEY) { updateCompareBar(); syncCompareChecks(); }
  });

  var pending = null;
  var observer = new MutationObserver(function () {
    if (pending) return;
    pending = window.requestAnimationFrame(function () { pending = null; refreshUI(document); });
  });

  function boot() {
    refreshUI(document);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('pageshow', function () { refreshUI(document); });
})();
